document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.getElementById("StickyATC");
  const stickyBtn = document.getElementById("StickyATCBtn");
  if (!sticky || !stickyBtn) return;

  // Standard: Sticky AUS bis wir sicher sind
  sticky.classList.remove("is-visible");
  sticky.setAttribute("aria-hidden", "true");

  const findMainAtcButton = () => {
    return (
      document.querySelector('product-form form button[type="submit"]') ||
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] button[name="add"]')
    );
  };

  let mainAtcBtn = findMainAtcButton();

  if (!mainAtcBtn) {
    let i = 0;
    const t = setInterval(() => {
      mainAtcBtn = findMainAtcButton();
      i++;
      if (mainAtcBtn || i >= 20) {
        clearInterval(t);
        if (mainAtcBtn) init(mainAtcBtn);
      }
    }, 150);
    return;
  }

  init(mainAtcBtn);

  function init(button) {
    const target = button.closest("product-form") || button.closest("form") || button;

    // 🔑 Wichtig: Sticky erst aktivieren, nachdem der normale ATC einmal sichtbar war
    let hasSeenMainATC = false;

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          hasSeenMainATC = true;                 // normaler ATC wurde gesehen
          sticky.classList.remove("is-visible"); // Sticky aus
          sticky.setAttribute("aria-hidden", "true");
          return;
        }

        // normaler ATC ist NICHT sichtbar:
        // Sticky NUR zeigen, wenn er vorher einmal sichtbar war
        if (hasSeenMainATC) {
          sticky.classList.add("is-visible");
          sticky.setAttribute("aria-hidden", "false");
        } else {
          sticky.classList.remove("is-visible");
          sticky.setAttribute("aria-hidden", "true");
        }
      },
      { threshold: 0.01 }
    );

    io.observe(target);

    stickyBtn.addEventListener("click", () => button.click());
  }
});
